import Entity from './entity'
export default class Factory extends Entity<number>{
    fname:string;
    status:Number=1;
}